/**
 * Fade In Animation Component
 * 画面にスクロールしたときにフェードインアニメーションを実行
 */

class FadeInAnimation {
  constructor() {
    this.elements = [];
    this.options = {
      rootMargin: '0px 0px 50px 0px', // 50px早めにトリガー
      threshold: 0.1 // 10%見えたらトリガー
    };

    this.init();
  }

  init() {
    // フェードイン対象の要素を取得
    this.setFadeInElements();

    // Intersection Observer をサポートしているかチェック
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersect.bind(this), this.options);
      this.observeElements();
    } else {
      // フォールバック：即座に全て表示
      this.showAllElements();
    }
  }

  setFadeInElements() {
    // 各セクションを順番にフェードイン（背景は除く）
    const selectors = [
      '.p-mv__content',     // メインビジュアル（コンテンツのみ）
      '.p-feature__inner',  // 特徴セクション（背景除く）
      '.p-worry__inner',    // 悩みセクション（背景除く）
      '.p-solution__content', // ソリューションセクション（背景除く）
      '.p-schedule__inner', // 1日のスケジュールセクション（背景除く）
      '.p-education__inner', // 教育制度セクション（背景除く）
      '.p-voice__inner',    // 先輩の声セクション（背景除く）
      '.p-faq__inner',      // FAQセクション（背景除く）
      '.p-job__inner',      // 募集要項セクション（背景除く）
      '.p-contact__inner'   // コンタクトセクション（背景除く）
    ];

    selectors.forEach((selector, index) => {
      const element = document.querySelector(selector);
      if (element) {
        // 初期状態を設定
        element.classList.add('js-fade-in');
        element.style.opacity = '0';
        element.style.translate = '0 20px';
        element.style.transition = 'opacity 0.6s ease-out, translate 0.6s ease-out';

        // 遅延時間を設定（同時に複数見える場合の調整）
        element.style.transitionDelay = `${index * 0.05}s`;

        this.elements.push(element);
      }
    });

    // 個別アイテムもフェードイン対象に追加
    this.addItemAnimations();
  }

  addItemAnimations() {
    // 特徴セクションの個別アイテム
    const featureItems = document.querySelectorAll('.p-feature__item');
    featureItems.forEach((item, index) => {
      item.classList.add('js-fade-in-item');
      item.style.opacity = '0';
      item.style.translate = '0 15px';
      item.style.transition = 'opacity 0.5s ease-out, translate 0.5s ease-out';
      item.style.transitionDelay = `${index * 0.15}s`;
      this.elements.push(item);
    });

    // 悩みセクションの個別アイテム
    const worryItems = document.querySelectorAll('.p-worry__list-item');
    worryItems.forEach((item, index) => {
      item.classList.add('js-fade-in-item');
      item.style.opacity = '0';
      item.style.translate = '0 15px';
      item.style.transition = 'opacity 0.5s ease-out, translate 0.5s ease-out';
      item.style.transitionDelay = `${index * 0.1}s`;
      this.elements.push(item);
    });

    // スケジュールセクションのタイムラインアイテム
    const scheduleItems = document.querySelectorAll('.p-schedule__timeline-item');
    scheduleItems.forEach((item, index) => {
      item.classList.add('js-fade-in-item');
      item.style.opacity = '0';
      item.style.translate = '0 15px';
      item.style.transition = 'opacity 0.5s ease-out, translate 0.5s ease-out';
      item.style.transitionDelay = `${index * 0.08}s`;
      this.elements.push(item);
    });

    // 教育制度セクションのカード
    const educationCards = document.querySelectorAll('.p-education-card');
    educationCards.forEach((card, index) => {
      card.classList.add('js-fade-in-item');
      card.style.opacity = '0';
      card.style.translate = '0 20px';
      card.style.transition = 'opacity 0.6s ease-out, translate 0.6s ease-out';
      card.style.transitionDelay = `${index * 0.2}s`;
      this.elements.push(card);
    });

    // 先輩の声の個別アイテム
    const voiceItems = document.querySelectorAll('.p-voice__item');
    voiceItems.forEach((item, index) => {
      item.classList.add('js-fade-in-item');
      item.style.opacity = '0';
      item.style.translate = '0 15px';
      item.style.transition = 'opacity 0.5s ease-out, translate 0.5s ease-out';
      item.style.transitionDelay = `${index * 0.2}s`;
      this.elements.push(item);
    });

    // FAQの個別アイテム
    const faqItems = document.querySelectorAll('.p-faq__item');
    faqItems.forEach((item, index) => {
      item.classList.add('js-fade-in-item');
      item.style.opacity = '0';
      item.style.translate = '0 10px';
      item.style.transition = 'opacity 0.4s ease-out, translate 0.4s ease-out';
      item.style.transitionDelay = `${index * 0.08}s`;
      this.elements.push(item);
    });

    // 募集要項の個別アイテム
    const jobItems = document.querySelectorAll('.p-job__item');
    jobItems.forEach((item, index) => {
      item.classList.add('js-fade-in-item');
      item.style.opacity = '0';
      item.style.translate = '0 10px';
      item.style.transition = 'opacity 0.4s ease-out, translate 0.4s ease-out';
      item.style.transitionDelay = `${index * 0.05}s`;
      this.elements.push(item);
    });

    // ソリューションセクションの個別要素
    const solutionDemoBubbleBg = document.querySelector('.p-solution__demo-bubble-bg');
    if (solutionDemoBubbleBg) {
      solutionDemoBubbleBg.classList.add('js-fade-in-item');
      solutionDemoBubbleBg.style.opacity = '0';
      solutionDemoBubbleBg.style.translate = '0 20px';
      solutionDemoBubbleBg.style.transition = 'opacity 0.6s ease-out, translate 0.6s ease-out';
      solutionDemoBubbleBg.style.transitionDelay = '0.3s';
      this.elements.push(solutionDemoBubbleBg);
    }

    const solutionPerson = document.querySelector('.p-solution__person-image');
    if (solutionPerson) {
      solutionPerson.classList.add('js-fade-in-item');
      solutionPerson.style.opacity = '0';
      solutionPerson.style.translate = '0 20px';
      solutionPerson.style.transition = 'opacity 0.8s ease-out, translate 0.8s ease-out';
      solutionPerson.style.transitionDelay = '0.2s';
      this.elements.push(solutionPerson);
    }

    // ソリューションのでも吹き出し全体
    const solutionDemoBubble = document.querySelector('.p-solution__demo-bubble');
    if (solutionDemoBubble) {
      solutionDemoBubble.classList.add('js-fade-in-item');
      solutionDemoBubble.style.opacity = '0';
      solutionDemoBubble.style.translate = '0 20px';
      solutionDemoBubble.style.transition = 'opacity 0.7s ease-out, translate 0.7s ease-out';
      solutionDemoBubble.style.transitionDelay = '0.5s';
      this.elements.push(solutionDemoBubble);
    }

    // フィーチャーセクションのタイトルバンドテキスト
    const featureTitleBand = document.querySelector('.p-feature__title-band-text');
    if (featureTitleBand) {
      featureTitleBand.classList.add('js-fade-in-item');
      featureTitleBand.style.opacity = '0';
      featureTitleBand.style.translate = '0 20px';
      featureTitleBand.style.transition = 'opacity 0.6s ease-out, translate 0.6s ease-out';
      featureTitleBand.style.transitionDelay = '0.4s';
      this.elements.push(featureTitleBand);
    }

    // ソリューションセクションの追加メッセージ
    const solutionMessage = document.querySelector('.p-solution__message');
    if (solutionMessage) {
      solutionMessage.style.opacity = '0';
      solutionMessage.style.translate = '0 20px';
      solutionMessage.style.transition = 'opacity 0.6s ease-out, translate 0.6s ease-out';
      this.elements.push(solutionMessage);
    }

  }

  observeElements() {
    this.elements.forEach(element => {
      this.observer.observe(element);
    });
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.animateElement(entry.target);
        this.observer.unobserve(entry.target);
      }
    });
  }

  animateElement(element) {
    // アニメーション実行
    requestAnimationFrame(() => {
      element.style.opacity = '1';
      element.style.translate = '0 0';
    });

    // アニメーション完了後にスタイルをクリーンアップ
    setTimeout(() => {
      element.style.transition = '';
      element.style.transitionDelay = '';
    }, 1000);
  }

  showAllElements() {
    // フォールバック：全ての要素を即座に表示
    this.elements.forEach(element => {
      element.style.opacity = '1';
      element.style.translate = '0 0';
    });
  }

  // パフォーマンス考慮：リサイズ時の処理
  handleResize() {
    // 必要に応じてリサイズ処理を追加
  }

  // クリーンアップ
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// 特別なセクション用のアニメーション
class SpecialAnimations {
  constructor() {
    this.init();
  }

  init() {
    // ヘッダーの特別なアニメーション
    this.animateHeader();

    // メインビジュアルのタイトルアニメーション
    this.animateMainVisual();
  }

  animateHeader() {
    const header = document.querySelector('.p-header');
    if (header) {
      header.style.opacity = '0';
      header.style.translate = '0 -10px';
      header.style.transition = 'opacity 0.5s ease-out, translate 0.5s ease-out';

      // ページロード後にアニメーション開始
      setTimeout(() => {
        header.style.opacity = '1';
        header.style.translate = '0 0';
      }, 100);
    }
  }

  animateMainVisual() {
    const mvTitle = document.querySelector('.p-mv__title');
    const mvSubtitle = document.querySelector('.p-mv__subtitle');
    const mvButton = document.querySelector('.p-mv__cta');

    if (mvTitle) {
      mvTitle.style.opacity = '0';
      mvTitle.style.translate = '0 15px';
      mvTitle.style.transition = 'opacity 0.6s ease-out, translate 0.6s ease-out';

      setTimeout(() => {
        mvTitle.style.opacity = '1';
        mvTitle.style.translate = '';
        // アニメーション完了後にスタイルをクリーンアップ
        setTimeout(() => {
          mvTitle.style.transition = '';
        }, 600);
      }, 200);
    }

    if (mvSubtitle) {
      mvSubtitle.style.opacity = '0';
      mvSubtitle.style.translate = '0 15px';
      mvSubtitle.style.transition = 'opacity 0.6s ease-out, translate 0.6s ease-out';

      setTimeout(() => {
        mvSubtitle.style.opacity = '1';
        mvSubtitle.style.translate = '';
        // アニメーション完了後にスタイルをクリーンアップ
        setTimeout(() => {
          mvSubtitle.style.transition = '';
        }, 600);
      }, 350);
    }

    if (mvButton) {
      mvButton.style.opacity = '0';
      mvButton.style.translate = '0 15px';
      mvButton.style.transition = 'opacity 0.6s ease-out, translate 0.6s ease-out';

      setTimeout(() => {
        mvButton.style.opacity = '1';
        mvButton.style.translate = '';
        // アニメーション完了後にスタイルをクリーンアップ
        setTimeout(() => {
          mvButton.style.transition = '';
        }, 600);
      }, 500);
    }
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  // フェードインアニメーションを初期化
  window.fadeInAnimation = new FadeInAnimation();

  // 特別なアニメーションを初期化
  window.specialAnimations = new SpecialAnimations();
});

// リサイズ時の処理
window.addEventListener('resize', () => {
  if (window.fadeInAnimation) {
    window.fadeInAnimation.handleResize();
  }
});

// ページを離れる際のクリーンアップ
window.addEventListener('beforeunload', () => {
  if (window.fadeInAnimation) {
    window.fadeInAnimation.destroy();
  }
});
